import { iots } from '@code-expert/prelude';
import { CourseUrl, GroupId, SemesterId } from '/imports/domain';

export const pageKeys = {
  details: null,
  reviewPresentations: null,
  schedulePresentations: null,
  reviewExercises: null,
  students: null,
  participation: null,
};

export const Page = iots.keyof(pageKeys);
export type Page = keyof typeof pageKeys;

const GroupsPageParamsWithoutGroup = iots.strict({
  semester: SemesterId,
  courseUrl: CourseUrl,
});

export type GroupsPageParamsWithoutGroup = iots.TypeOf<typeof GroupsPageParamsWithoutGroup>;

const GroupsPageParamsWithGroup = iots.strict({
  semester: SemesterId,
  courseUrl: CourseUrl,
  page: Page,
  groupId: GroupId,
});

export type GroupsPageParamsWithGroup = iots.TypeOf<typeof GroupsPageParamsWithGroup>;

export const GroupsPageParams = iots.union([
  // The order is important since the iots.union decoder returns the first match
  GroupsPageParamsWithGroup,
  GroupsPageParamsWithoutGroup,
]);

export type GroupsPageParams = iots.TypeOf<typeof GroupsPageParams>;

export const hasGroup = (group: GroupsPageParams): group is GroupsPageParamsWithGroup =>
  'groupId' in group && group.groupId != null;

export const foldGroupsPageParams =
  <A>(pattern: {
    withGroup: (_: GroupsPageParamsWithGroup) => A;
    withoutGroup: (_: GroupsPageParamsWithoutGroup) => A;
  }) =>
  (group: GroupsPageParams): A =>
    hasGroup(group) ? pattern.withGroup(group) : pattern.withoutGroup(group);

export const defaultPage: Page = 'reviewExercises';
